
import { INofeshTashlumim } from './model/nofesh-tashlumim';
import { INofeshPaymentTashlumim } from './model/nofesh-payment-tashlumim';

import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs/Rx';
import { Injectable } from "@angular/core";
import { Response, URLSearchParams } from '@angular/http';

import { HttpService } from '../shared/http.service';
import { AppSettings } from '../shared/app-settings'
import { INofesh } from "./model/nofesh";
import { IPrice } from "./model/price";
import { INirsham } from "./model/nirsham";
import { INofeshOrderNirshamim } from "./model/nofesh-order-nirshamim";
import { INofeshPayment } from './model/nofesh-payment';
import { INofeshUploads } from './model/nofesh-uploads';
import { ResultOfOperation } from '../shared/model/result-of-operation.model';
import { SpinnerService } from '../shared/spinner/spinner.service';
import { tap } from 'rxjs/operators';
import { INofeshSelected } from '../shared/interfaces/Inofesh-selected.interface';
import { ConfigService } from 'app/shared/config.service';
import { updateLocale } from 'moment';
import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { IFavoritesNofashim } from './model/favorites-nofashim.interface';
import { environment } from 'environments/environment';

@Injectable()
export class NofeshService {
    private apiUrl: string = "";

    private _cancelReservationFailure: Subject<void> = new Subject<void>();
    cancelReservationFailure$: Observable<void> = this._cancelReservationFailure.asObservable();

    constructor(
        private _http: HttpService,
        private _httpClient: HttpClient,
        private _spinnerService: SpinnerService,
        private _configService: ConfigService
    ) {
        this.apiUrl = this._configService.getConfigPropertyByKey("apiUrl");
    }

    notifyFailedToCancelReservation(): void {
        console.log("Nofesh service - notifying failed cancel");
        this._cancelReservationFailure.next();
    }

    getAllNofashim(): Observable<ResultOfOperation<INofesh[]>> {
        this._spinnerService.showSpinner();
        let url: string = `${this.apiUrl}/api/Nofesh/GetAllNofashim`;
        return this._httpClient.get<ResultOfOperation<INofesh[]>>(url)
            .pipe(tap(
                response => {
                    this._spinnerService.hideSpinner();
                },
                error => {
                    this._spinnerService.hideSpinner();
                }
            ));
    }

    getCurrentNofesh(id_nofesh: number): Observable<INofesh> {
        let url: string = `${this.apiUrl}/api/Nofesh/GetCurrentNofesh`
        let params: URLSearchParams = new URLSearchParams();
        params.set('id_nofesh', id_nofesh.toString());
        return this._http.get(url, { search: params })
            .map((response: Response) => <INofesh>response.json())
            .catch(this.handleError);
    }

    getNofeshPrices(id_nofesh: number): Observable<IPrice[]> {
        let url: string = `${this.apiUrl}/api/Nofesh/GetNofeshPrices`
        let params: URLSearchParams = new URLSearchParams();
        params.set('id_nofesh', id_nofesh.toString());
        this._spinnerService.showSpinner();
        return this._http.get(url, { search: params })
            .pipe(
                tap(_ => {
                    this._spinnerService.hideSpinner();
                }, error => {
                    this._spinnerService.hideSpinner();
                })
            )
            .map((response: Response) => <IPrice[]>response.json())
            .catch(this.handleError);
    }

    getNofeshNirshamim(id_nofesh: number, isNirshamimChul?: boolean): Observable<INirsham[]> {
        if (isNirshamimChul) {
            let url: string = `${this.apiUrl}/api/Nofesh/GetNofshonNirshamim`
            return this._http.get(url + "?nofshonId=" + id_nofesh)
                .map((response: Response) => response.json())
                .catch(this.handleError);

        }
        else {

            let params: URLSearchParams = new URLSearchParams();
            params.set('id_nofesh', id_nofesh.toString());
            let url: string = `${this.apiUrl}/api/Nofesh/GetNofeshNirshamim`
            return this._http.get(url, { search: params })
                .map((response: Response) => <INirsham[]>response.json())
                .catch(this.handleError);
        }
    }


    getNofeshNirshamimHeaderPanel(nofeshId: number, isNirshamimChul?: boolean): Observable<INirsham[]> {
        //
        // TODO: instead of this method, use isReservationCompleted property of INofeshSelected
        //

        if (isNirshamimChul) {
            let params: URLSearchParams = new URLSearchParams();
            let url: string = `${this.apiUrl}/api/Nofesh/GetNofshonNirshamim`
            params.set('nofeshId', nofeshId.toString())
            return this._http.get(url, { search: params })
                .map((response: Response) => response.json())
                .catch(this.handleError);
        }
        else {

            let params: URLSearchParams = new URLSearchParams();
            params.set('id_nofesh', nofeshId.toString());
            let url: string = `${this.apiUrl}/api/Nofesh/GetNofeshNirshamim`
            return this._http.get(url, { search: params })
                .map((response: Response) => <INirsham[]>response.json())
                .catch(this.handleError);
        }
    }


    saveNofeshNirshamim(model: INofeshOrderNirshamim): Observable<any> {
        let url: string = `${this.apiUrl}/api/Nofesh/SaveNofeshNirshamim`
        return this._http.post(url, JSON.stringify(model))
            .map(res => res.json())
            .catch(this.handleError)
    }

    getNofeshPayment(nofeshId: number): Observable<INofeshPaymentTashlumim> {
        let url: string = `${this.apiUrl}/api/Nofesh/GetNofeshPayment`
        let params: URLSearchParams = new URLSearchParams();
        params.set('nofeshId', nofeshId.toString());
        return this._http.get(url, { search: params })
            .map((response: Response) => <INofeshPaymentTashlumim>response.json())
            .catch(this.handleError)
    }

    saveNofeshTashlumim(model: INofeshTashlumim): Observable<any> {
        let url: string = `${this.apiUrl}/api/Nofesh/SaveNofeshTashlumim`
        return this._http.post(url, JSON.stringify(model))
            .map(res => res.json())
            .catch(this.handleError)
    }


    getNofeshUploads(nofeshId: number): Observable<INofeshUploads[]> {
        let url: string = `${this.apiUrl}/api/Nofesh/GetNofeshUploads`
        let params: URLSearchParams = new URLSearchParams();
        params.set('nofeshId', nofeshId.toString());
        return this._http.get(url, { search: params })
            .map((response: Response) => <INofeshUploads[]>response.json())
            .catch(this.handleError)
    }

    getUserSelectedNofesh(nofeshId: number): Observable<INofeshSelected> {
        let url: string = `${this.apiUrl}/api/Nofesh/GetUserSelectedNofesh`
        let params: URLSearchParams = new URLSearchParams();
        params.set('nofeshId', nofeshId.toString());
        return this._http.get(url, { search: params })
            // .pipe(
            //     tap((response: INofeshSelected) => {
            //         if(!environment.production) console.log("Nofesh Service - user selected nofesh", response);
            //     })
            // )
            .map((response: Response) => <INofeshSelected>response.json())
            .catch(this.handleError);
    }

    cancelNofeshReservation(idNofesh: number): Observable<ResultOfOperation<boolean>> {
        this._spinnerService.showSpinner();
        const url = `${this.apiUrl}/api/Nofesh/CancelNofeshReservation`;
        return this._httpClient.post<ResultOfOperation<boolean>>(url, { idNofesh })
            .pipe(
                tap(success => {
                    this._spinnerService.hideSpinner();
                }, error => {
                    this._spinnerService.hideSpinner();
                })
            );
    }


    saveNofeshEndRishum(nofeshId: number): Observable<any> {
        let url: string = `${this.apiUrl}/api/Nofesh/SaveNofeshEndRishum`
        let params: URLSearchParams = new URLSearchParams();
        params.set('nofeshId', nofeshId.toString());
        return this._http.get(url, { search: params })
            .map((res: Response) => res.json())
            .catch(this.handleError)
    }

    getNirshamDetails(msZehut: number): Observable<INirsham> {
        let url: string = `${this.apiUrl}/api/Nofesh/GetNirshamDetails`
        let params: URLSearchParams = new URLSearchParams();
        params.set('msZehut', msZehut.toString());
        return this._http.get(url, { search: params })
            .map((response: Response) => <INirsham>response.json())
            .catch(this.handleError)
    }

    getFavoritesNofashim(): Observable<ResultOfOperation<IFavoritesNofashim>> {
        let url: string = `${this.apiUrl}/api/Nofesh/GetFavoritesNofashim`
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const options = {
            headers: headers
        };
        return this._httpClient.get<ResultOfOperation<IFavoritesNofashim>>(url, options);
    }

    private handleError(error: Response | any) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);

            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;

        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        //console.error(errMsg);
        return Observable.throw(errMsg);
    }

}